import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { LabelProps } from "../../../../../../utils/types";
import { Label } from "../../../../../../stories/Label/Label";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import Input from "../../../../../../stories/Input/Input";
import { Title } from "../../../../../../stories/Title/Title";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  handleFormEvent,
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";


import {
  RfqTrnSupply,
  RfqTrnSupplyItemDetails,
} from "../../../../../../utils/formTypes";
import { Operation, YesNo } from "../../../../../../utils/Enum.types";
import InputNumber from "../../../../../common/Input/InputNumber";
import { Form, Formik, FormikProps } from "formik";
import InputHoc from "../../../../../common/Input/Index";
import { rfqQuotationSchema } from "../../../../../../utils/validationSchema";
import {UpdateRfqTrnSupplyQuote } from "../queries/mutations";
import {
  UpdateRfqTrnSupplyQuoteResult,

  UpdateRfqTrnSupplyQuoteVars,
} from "../queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import { EMPTY_STRING, emptyMessage } from "../../../../../../utils/constants";
import MessageModal from "../../../../../../customComponents/MessageModal";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { GetRfqTrnSupplyByKey } from "../queries/queries";
import { GetRfqTrnSupplyNode } from "../../../masters/supplier/queries/queries";
import {
  GetRfqTrnSupplyNodeResult,
  GetRfqTrnSupplyNodeVars,
} from "../../../masters/supplier/queries/types";
import LoadingModal from "../../../../../pages/LoadingModal";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";

const inputJson: LabelProps[] = [
  {
    labelName: "Interested to Quote",
    inputName: "isAccepted",
    dataType: "yesno",
    autoFocus: true,
    formFields: [
      {
        labelName: "Change id desc (Yes/No)",
        inputName: "itemDescChanged",
        dataType: "yesno",
        formFields: [
          {
            labelName: "Enter New Description",
            inputName: "quotedDesc",
            dataType: "text",
          },
        ],
      },
      {
        labelName: "Quoted Qty",
        inputName: "quotedQty",
        dataType: "number",
      },
      {
        labelName: "Rate",
        inputName: "quotedRate",
        dataType: "number",
      },
      {
        labelName: "Any other Charges per Qty",
        inputName: "anyOtherCharges",
        dataType: "yesno",
        formFields: [
          {
            labelName: "Taxes %",
            inputName: "quotedTax",
            dataType: "number",
          },
          {
            labelName: "Delivery Charges",
            inputName: "quotedDelvChrg",
            dataType: "number",
          },
          {
            labelName: "Installation Charges",
            inputName: "quotedInstChrg",
            dataType: "number",
          },
          {
            labelName: "Other Charges",
            inputName: "quotedOtherChrg",
            dataType: "number",
          },
          {
            labelName: "Total Amount",
            inputName: "totalAmt",
            dataType: "number",
            disabled: true,
          },
        ],
      },
      {
        labelName: "Net Quoted",
        inputName: "net",
        dataType: "number",
        disabled: true,
      },
      {
        labelName: "Remarks",
        inputName: "quotedRemarks",
        dataType: "textarea",
      },
    ],
  },
];

const FillItemQuotation = () => {
  const navigate = useNavigate();
  const {Quotation}=useFormJson();
  const [file, setFile] = useState<File | null>(null);
  const [browse, setBrowse] = useState(false);
  const [interestedQuote, setInterestedQuote] = useState<string | null>(null);
  const [othercharges, setOtherCharges] = useState<string | null>(null);
  const [changeInDescription, setChangeInDescription] = useState<string | null>(
    null
  );

  const itemInitialValues: RfqTrnSupplyItemDetails = {
    itemDesc: "",
    item_desc: "",
    required_qty: "",
    terms: "",
    payment_terms: "",
  };

  const [itemDetails, setItemDetails] =
    useState<RfqTrnSupplyItemDetails>(itemInitialValues);

  const [GetRfqDetails, { data }] = useLazyQuery<
    GetRfqTrnSupplyNodeResult,
    GetRfqTrnSupplyNodeVars
  >(GetRfqTrnSupplyNode);

  const { uuid, rfqTrnSupplyId } = useUrlParams();

  const [message, setMessage] = useState(emptyMessage);

  const [Update, { loading }] = useMutation<
    UpdateRfqTrnSupplyQuoteResult,
    UpdateRfqTrnSupplyQuoteVars
  >(UpdateRfqTrnSupplyQuote, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const initialValues: RfqTrnSupply = {
    isAccepted: "",
    itemDescChanged: "",
    quotedDesc: "",
    quotedQty: "",
    quotedRate: "",
    quotedTax: "",
    totalAmt: "",
    quotedDelvChrg: "",
    quotedInstChrg: "",
    net: "",
    quotedRemarks: "",
    anyOtherCharges: "",
    quotedAnyChanges: "",
    quotedOtherChrg: "",
  };

  const [formData, setFormData] = useState<RfqTrnSupply>(initialValues);

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files[0];
      setFile(image_as_files);
    }
  };

  const changeValue = (
    approxRate: number,
    reqQty: number,
    deliveryRate: number,
    installationRate: number,
    otherRate: number,
    tax: number,
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    const taxable =
      Number(approxRate) * Number(reqQty) +
      Number(deliveryRate) +
      Number(installationRate) +
      Number(otherRate);

    const taxesValue = (Number(tax) / 100) * taxable;

    const netValue = taxable + taxesValue;

    setFormData({
      ...formData,
      [name]: value,
      totalAmt: taxable.toString(),
      net: netValue.toString(),
    });
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<RfqTrnSupply>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    switch (name) {
      case "reqQty":
        changeValue(
          Number(formData.quotedRate),
          Number(value),
          Number(formData.quotedDelvChrg),
          Number(formData.quotedInstChrg),
          Number(formData.quotedOtheChrg),
          Number(formData.quotedTax),
          e
        );
        meta.handleChange(e);
        break;
      case "approxRate":
        changeValue(
          Number(value),
          Number(formData.quotedQty),
          Number(formData.quotedDelvChrg),
          Number(formData.quotedInstChrg),
          Number(formData.quotedOtheChrg),
          Number(formData.quotedTax),
          e
        );
        meta.handleChange(e);
        break;
      case "deliveryRate":
        changeValue(
          Number(formData.quotedRate),
          Number(formData.quotedQty),
          Number(value),
          Number(formData.quotedInstChrg),
          Number(formData.quotedOtheChrg),
          Number(formData.quotedTax),
          e
        );
        meta.handleChange(e);
        break;
      case "installationRate":
        changeValue(
          Number(formData.quotedRate),
          Number(formData.quotedQty),
          Number(formData.quotedDelvChrg),
          Number(value),
          Number(formData.quotedOtheChrg),
          Number(formData.quotedTax),
          e
        );
        meta.handleChange(e);
        break;
      case "quotedOtherChrg":
        changeValue(
          Number(formData.quotedRate),
          Number(formData.quotedQty),
          Number(formData.quotedDelvChrg),
          Number(formData.quotedInstChrg),
          Number(value),
          Number(formData.quotedTax),
          e
        );
        meta.handleChange(e);
        break;
      case "tax":
        changeValue(
          Number(formData.quotedRate),
          Number(formData.quotedQty),
          Number(formData.quotedDelvChrg),
          Number(formData.quotedInstChrg),
          Number(formData.quotedOtheChrg),
          Number(value),
          e
        );
        meta.handleChange(e);
        break;
      default:
        setFormData(() => ({
          ...formData,
          [name]: value,
        }));
        meta.handleChange(e);
        break;
    }
  };

  const handleSubmit = () => {
    if (uuid && rfqTrnSupplyId) {
      const quotedTaxable =
        Number(formData.quotedQty) * Number(formData.quotedRate) +
        Number(formData.quotedDelvChrg) +
        Number(formData.quotedOtherChrg) +
        Number(formData.quotedInstChrg);

      const quotedValue =
        (Number(formData.quotedTax) / 100) * Number(quotedTaxable);
      Update({
        variables: {
          uuid,
          input: [
            {
              rfqTrnSupplyId,
              isAccepted: formData.isAccepted === YesNo.YES,
              itemDescChanged: formData.itemDescChanged === YesNo.YES,
              quotedDelvChrg: Number(formData.quotedDelvChrg),
              quotedDesc: formData.quotedDesc,
              quotedInstChrg: Number(formData.quotedInstChrg),
              quotedOther: Number(formData.quotedOtherChrg),
              quotedProductBrochure: EMPTY_STRING,
              quotedQty: Number(formData.quotedQty),
              quotedRate: Number(formData.quotedRate),
              quotedRemarks: removeMoreSpace(formData.quotedRemarks),
              quotedTax: Number(formData.quotedTax),
              quotedTaxable,
              quotedValue,
              quotedAnyChanges: formData.anyOtherCharges === YesNo.YES,
            },
          ],
        },
        refetchQueries: [
          {
            query: GetRfqTrnSupplyByKey,
            variables: {
              key: uuid,
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.UpdateRfqTrnSupplyQuote) {
          setMessage({
            flag: true,
            message: "Generated",
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (rfqTrnSupplyId && uuid)
      GetRfqDetails({
        variables: {
          id: rfqTrnSupplyId,
          key: uuid,
        },
      }).then(({ data }) => {
        if (data && data.GetRfqTrnSupplyNode) {
          setItemDetails({
            itemDesc: `${data.GetRfqTrnSupplyNode.item.desc} (${data.GetRfqTrnSupplyNode.item.code})`,
            item_desc: data.GetRfqTrnSupplyNode.rfqTrn.udfItemDesc,
            payment_terms: data.GetRfqTrnSupplyNode.rfqTrn.itemPaymentTerms,
            required_qty:
              data.GetRfqTrnSupplyNode.rfqTrn.mrf_trn_details.reqQty,
            terms: data.GetRfqTrnSupplyNode.rfqTrn.itemPaymentTerms,
          });
          if (data.GetRfqTrnSupplyNode.isAccepted) {
            const totalAmt =
              Number(
                data.GetRfqTrnSupplyNode.quotedQty *
                  data.GetRfqTrnSupplyNode.quotedRate
              ) +
              Number(data.GetRfqTrnSupplyNode.quotedDelvChrg) +
              Number(data.GetRfqTrnSupplyNode.quotedInstChrg) +
              Number(data.GetRfqTrnSupplyNode.quotedOther);

            const netValue =
              (data.GetRfqTrnSupplyNode.quotedTax / 100) * totalAmt;

            setFormData({
              isAccepted: data.GetRfqTrnSupplyNode.isAccepted
                ? YesNo.YES
                : YesNo.NO,
              anyOtherCharges: data.GetRfqTrnSupplyNode.quotedAnyChanges
                ? YesNo.YES
                : YesNo.NO,
              itemDescChanged: data.GetRfqTrnSupplyNode.itemDescChanged
                ? YesNo.YES
                : YesNo.NO,
              quotedAnyChanges: data.GetRfqTrnSupplyNode.quotedAnyChanges
                ? YesNo.YES
                : YesNo.NO,
              quotedDelvChrg:
                data.GetRfqTrnSupplyNode.quotedDelvChrg.toString(),
              quotedInstChrg:
                data.GetRfqTrnSupplyNode.quotedInstChrg.toString(),
              quotedDesc: data.GetRfqTrnSupplyNode.quotedDesc,
              quotedQty: data.GetRfqTrnSupplyNode.quotedQty.toString(),
              quotedRate: data.GetRfqTrnSupplyNode.quotedRate.toString(),
              quotedRemarks: data.GetRfqTrnSupplyNode.quotedRemarks,
              quotedTax: data.GetRfqTrnSupplyNode.quotedTax.toString(),
              totalAmt: totalAmt.toString(),
              net: netValue.toString(),
              quotedOtherChrg: data.GetRfqTrnSupplyNode.quotedOther.toString(),
            });
          }
        }
      });
  }, [GetRfqDetails, rfqTrnSupplyId, uuid, data]);
const {itemLabel}=useLabels();
  return (
    <>
      <div className="fill-item-q">
        <div className="fill-item-q__block">
          <div className="fill-item-q__block--header">
            <Title>Fill {itemLabel} Quotation</Title>
          </div>
          <div className="fill-item-q__block--subheader">
            <span>Quotation for</span>
            <b>{itemDetails.itemDesc}</b>
          </div>
          {/* use below div for form */}
          <Formik
            initialValues={formData}
            validationSchema={rfqQuotationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
            validateOnChange
          >
            {(meta) => {
              return (
                <Form className="fill-item-q__block--data ">
                  <div className="fill-item-q__block--data--flex row g-0">
                    <div className="fill-item-q__block--data--left col">
                      <Title variant="subtitle1">{itemLabel} Details</Title>
                      {Quotation.FillItem.ItemDetails.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  rows={2}
                                  disabled
                                  value={itemDetails[field.inputName]}
                                />
                              </div>
                            );
                          } else
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <Input
                                  disabled
                                  value={itemDetails[field.inputName]}
                                />
                              </div>
                            );
                        }
                      )}
                    </div>
                    <div className="fill-item-q__block--data--right col">
                      <Title variant="subtitle1">Quotation Details</Title>
                      <div className="fill-item-q__block--data--right--block">
                        {inputJson.map((field: LabelProps, key: React.Key) => {
                          if (field.dataType === "yesno") {
                            return (
                              <>
                                <div className="label-grid">
                                  <Label>{field.labelName}</Label>
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={Object.values(YesNo)}
                                    onKeyDown={(e) => {
                                      if (e.key === Keys.ENTER) {
                                        e.preventDefault();
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    value={
                                      formData[field.inputName]
                                        ? formData[field.inputName]
                                        : null
                                    }
                                    onChange={(e, newValue) => {
                                      setFormData({
                                        ...formData,
                                        [field.inputName]: newValue as string,
                                      });
                                    }}
                                    openOnFocus
                                    forcePopupIcon
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />
                                </div>

                                {formData[field.inputName] === YesNo.YES &&
                                field.formFields
                                  ? field.formFields.map(
                                      (inField: LabelProps, key: React.Key) => {
                                        if (inField.dataType === "yesno") {
                                          return (
                                            <>
                                              <div className="label-grid">
                                                <Label>
                                                  {inField.labelName}
                                                </Label>
                                                <FormAutocomplete
                                                  className={
                                                    formClasses.inputRoot
                                                  }
                                                  options={Object.values(YesNo)}
                                                  onKeyDown={(e) => {
                                                    if (e.key === Keys.ENTER) {
                                                      e.preventDefault();
                                                      handleMUISelectEvent(e);
                                                    }
                                                  }}
                                                  value={
                                                    formData[inField.inputName]
                                                      ? formData[
                                                          inField.inputName
                                                        ]
                                                      : null
                                                  }
                                                  onChange={(e, newValue) => {
                                                    setFormData({
                                                      ...formData,
                                                      [inField.inputName]:
                                                        newValue as string,
                                                    });
                                                  }}
                                                  openOnFocus
                                                  forcePopupIcon
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      fullWidth
                                                      className={
                                                        formClasses.formControlRoot
                                                      }
                                                    />
                                                  )}
                                                />
                                              </div>
                                              {formData[inField.inputName] ===
                                                YesNo.YES && inField.formFields
                                                ? inField.formFields.map(
                                                    (
                                                      sub_field: LabelProps,
                                                      key: React.Key
                                                    ) => {
                                                      if (
                                                        sub_field.dataType ===
                                                        "number"
                                                      ) {
                                                        return (
                                                          <div className="label-grid">
                                                            <Label>
                                                              {
                                                                sub_field.labelName
                                                              }
                                                            </Label>
                                                            <InputNumber
                                                              name={
                                                                sub_field.inputName
                                                              }
                                                              value={
                                                                formData[
                                                                  sub_field
                                                                    .inputName
                                                                ]
                                                              }
                                                              onChange={(
                                                                e: React.ChangeEvent<HTMLInputElement>
                                                              ) => {
                                                                handleValueChange(
                                                                  e,
                                                                  meta
                                                                );
                                                              }}
                                                              onKeyDown={
                                                                handleFormEvent
                                                              }
                                                              disabled={
                                                                sub_field.disabled
                                                              }
                                                            />
                                                          </div>
                                                        );
                                                      } else if (
                                                        sub_field.dataType ===
                                                        "textarea"
                                                      ) {
                                                        return (
                                                          <div className="label-grid">
                                                            <Label>
                                                              {
                                                                sub_field.labelName
                                                              }
                                                            </Label>
                                                            <TextArea
                                                              rows={2}
                                                              name={
                                                                sub_field.inputName
                                                              }
                                                              value={
                                                                formData[
                                                                  sub_field
                                                                    .inputName
                                                                ]
                                                              }
                                                              onChange={(
                                                                e: React.ChangeEvent<HTMLTextAreaElement>
                                                              ) => {
                                                                handleValueChange(
                                                                  e,
                                                                  meta
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        );
                                                      } else {
                                                        return (
                                                          <div className="label-grid">
                                                            <Label>
                                                              {
                                                                sub_field.labelName
                                                              }
                                                            </Label>
                                                            <InputHoc
                                                              name={
                                                                sub_field.inputName
                                                              }
                                                              values={
                                                                formData[
                                                                  sub_field
                                                                    .inputName
                                                                ]
                                                              }
                                                              onChange={(
                                                                e: React.ChangeEvent<HTMLInputElement>
                                                              ) => {
                                                                handleValueChange(
                                                                  e,
                                                                  meta
                                                                );
                                                              }}
                                                              onKeyDown={
                                                                handleFormEvent
                                                              }
                                                            />
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )
                                                : null}
                                            </>
                                          );
                                        } else if (
                                          inField.dataType === "number"
                                        ) {
                                          return (
                                            <div className="label-grid">
                                              <Label>{inField.labelName}</Label>
                                              <InputNumber
                                                name={inField.inputName}
                                                value={
                                                  formData[inField.inputName]
                                                }
                                                onKeyDown={handleFormEvent}
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                  handleValueChange(e, meta);
                                                }}
                                                disabled={inField.disabled}
                                              />
                                            </div>
                                          );
                                        } else if (
                                          inField.dataType === "textarea"
                                        ) {
                                          return (
                                            <div className="label-grid">
                                              <Label>{inField.labelName}</Label>
                                              <TextArea
                                                rows={2}
                                                name={inField.inputName}
                                                value={
                                                  formData[inField.inputName]
                                                }
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                                ) => {
                                                  handleValueChange(e, meta);
                                                }}
                                              />
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <div className="label-grid">
                                              <Label>{field.labelName}</Label>
                                              <InputHoc
                                                name={field.inputName}
                                                value={
                                                  formData[field.inputName]
                                                }
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                  handleValueChange(e, meta);
                                                }}
                                                onKeyDown={handleFormEvent}
                                              />
                                            </div>
                                          );
                                        }
                                      }
                                    )
                                  : null}
                              </>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  name={field.inputName}
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  onKeyDown={handleFormEvent}
                                  disabled={field.disabled}
                                />
                              </div>
                            );
                          } else if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  rows={2}
                                  name={field.inputName}
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  // onKeyDown={handleMUISelectEvent}
                                />
                              </div>
                            );
                          } else {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputHoc
                                  name={field.inputName}
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>
                  </div>
                  <Button mode="save" type="submit" />
                  <Button mode="back" onClick={() => navigate(-1)} />
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>

      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={loading} />
    </>
  );
};

export default FillItemQuotation;
